import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

interface ProposalTemplateDetailCardProps {
  title: string;
  isVisible: boolean;
}

const ProposalTemplateDetailCard: React.FC<
  PropsWithChildren<ProposalTemplateDetailCardProps>
> = ({ title, isVisible, children }) => (
  <Box
    sx={{
      borderRadius: 3,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      padding: 4,
      display: isVisible ? 'flex' : 'none',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <Typography variant="subtitle2">{title}</Typography>

    {children}
  </Box>
);

export default ProposalTemplateDetailCard;
